// UserProvider.js
import React, { useState, useMemo, useEffect, useCallback } from "react";
import SubjectsContext from "./SubjectsContext";

const SUBJECTS_LOAD_TIMEOUT_MS = 10000;

export const SubjectsProvider = ({ children }) => {
  const [subjects, setSubjectsState] = useState([]);
  const [subjectsStatus, setSubjectsStatus] = useState("loading");
  const [snapshotIssue, setSnapshotIssue] = useState(null);
  const [loadGeneration, setLoadGeneration] = useState(0);

  const setSubjects = useCallback((value) => {
    if (typeof value !== "function")
      setSubjectsStatus(value == null ? "loading" : "ready");
    if (value == null) setLoadGeneration((generation) => generation + 1);
    setSubjectsState(value);
  }, []);

  useEffect(() => {
    if (subjectsStatus !== "loading") return;
    const timer = setTimeout(
      () => setSubjectsStatus((s) => (s === "loading" ? "unavailable" : s)),
      SUBJECTS_LOAD_TIMEOUT_MS,
    );
    return () => clearTimeout(timer);
  }, [subjectsStatus, loadGeneration]);

  // Context value now includes the function to fetch user data
  const contextValue = useMemo(
    () => ({
      subjects,
      setSubjects,
      subjectsStatus,
      snapshotIssue,
      setSnapshotIssue,
    }),
    [subjects, setSubjects, subjectsStatus, snapshotIssue],
  );

  return (
    <SubjectsContext.Provider value={contextValue}>
      {children}
    </SubjectsContext.Provider>
  );
};
